
import { formatCostDecimal as formatCostDecimalDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatCostProps = {
    cost: number;
}

export const formatCostDecimal = ({ cost }: FormatCostProps): string =>
    formatCostDecimalDiagram(cost);
